/**
 * Global roles live on `users.global_role` and are NOT competition roles.
 *
 * This is the one role column allowed on `users`: it answers "may this account
 * administer the platform itself". Per-competition roles must always be read
 * from `competition_roles`, because the same user can be a judge in one
 * competition and a student in another.
 */
export const GLOBAL_ROLES = {
  USER: 'user',
  SUPER_ADMIN: 'super_admin',
} as const

export type GlobalRole = (typeof GLOBAL_ROLES)[keyof typeof GLOBAL_ROLES]

export const GLOBAL_ROLE_VALUES = Object.values(GLOBAL_ROLES) as [GlobalRole, ...GlobalRole[]]

/**
 * Roles scoped to a single competition. Stored in `competition_roles`
 * (introduced in Phase 2) as `(user_id, competition_id, role)`.
 */
export const COMPETITION_ROLES = {
  COMPETITION_ADMIN: 'competition_admin',
  STAFF: 'staff',
  STUDENT: 'student',
  TEACHER: 'teacher',
  JUDGE: 'judge',
  OBSERVER: 'observer',
} as const

export type CompetitionRole = (typeof COMPETITION_ROLES)[keyof typeof COMPETITION_ROLES]

export const COMPETITION_ROLE_VALUES = Object.values(COMPETITION_ROLES) as [
  CompetitionRole,
  ...CompetitionRole[],
]
